exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bottom-button[data-v-0095aaf5] {\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  z-index: 100;\n}\n.position-fixed[data-v-0095aaf5] {\r\n  position: fixed;\r\n  bottom: 0px;\n}\n.position-absolute[data-v-0095aaf5] {\r\n  position: absolute;\n}\n.blueBt[data-v-0095aaf5]{\r\n  background: #18b4ed;\n}\r\n", ""]);

// exports
